import React from "react";

import { SVG_TEXT_FILL, SVG_TEXT_SX, SvgTextVariant } from "./constants";
import { SocialShareCardPalette } from "./types";

export const SvgText = React.forwardRef<
    SVGTextElement,
    {
        x: number;
        y: number;
        palette: SocialShareCardPalette;
        variant: SvgTextVariant;
        children: string;
        center?: boolean;
    }
>(({ x, y, palette, children, variant, center }, ref) => {
    return (
        <text
            ref={ref}
            x={x}
            y={y}
            fill={palette[SVG_TEXT_FILL[variant]]}
            letterSpacing="-0.01em"
            fontFamily="ABC Diatype Unlicensed Trial"
            textAnchor={center ? "middle" : "start"}
            style={{ whiteSpace: "pre", ...SVG_TEXT_SX[variant] }}
        >
            <tspan>{children}</tspan>
        </text>
    );
});
